import * as React from 'react';
import { useRecordContext } from 'react-admin';
import BusinessViewCount from '../components/BusinessViewCount';

const BusinessAside = () => {
	const record = useRecordContext();
	if (!record) { return null; }
	return (
		<BusinessViewCount
			id={record.mainVersion?.id || record.id}
			style={{
				maxHeight: '40vh', padding: '10px', maxWidth: '20%', minWidth: '10%',
			}}
		/>
	);
};

export default BusinessAside;
